import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create overage entry and return same object
 */

export const CreateOverageEntryAPI = async (params: IOvEntry) => {
  try {
    const response = await axios.post(getUrl(ApiType.OVERAGE_CREATE), params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createOverageEntry, { badRequestOrder: "errorsFirst" });
  }
};
